import { type ReactElement } from 'react';
import clsx from 'clsx';
import { TdsIcon } from '@scania/tegel-react';
import styles from './style.module.scss';

interface StatusCellProperties {
  readonly vehicleAlert: boolean;
}

const StatusCell = ({ vehicleAlert }: StatusCellProperties): ReactElement => (
  <div
    className={clsx(styles.container, { [styles.warning]: vehicleAlert })}
    aria-label={vehicleAlert ? 'Alert' : undefined}
  >
    {vehicleAlert ? <TdsIcon name="warning" size="20px" /> : null}
  </div>
);

export default StatusCell;
